const PATHS = {
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20.5 20.5l-4.6-4.6',
  star: 'M12 3.6l2.6 5.2 5.8.9-4.2 4.1 1 5.7L12 16.8l-5.2 2.7 1-5.7-4.2-4.1 5.8-.9z',
  pin: 'M12 21s-6.5-5.6-6.5-10.5a6.5 6.5 0 0 1 13 0C18.5 15.4 12 21 12 21zM12 12.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  video: 'M3.5 7h11v10h-11zM14.5 10.5l6-3.2v9.4l-6-3.2',
  file: 'M14 3H6.5v18h11V6.5zM14 3v3.5h3.5M9 12.5h6M9 16h6',
  close: 'M6 6l12 12M18 6L6 18',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  alert: 'M12 4l9 16H3zM12 10v4.2M12 17.2v.3',
  clock: 'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zM12 7.5V12l3 2',
  copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
  ext: 'M14 4h6v6M20 4l-8.5 8.5M18 14v6H4V6h6',
  cal: 'M4 5.5h16V20H4zM4 10h16M8.5 3v4M15.5 3v4',
  info: 'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zM12 11v5.5M12 7.8v.2',
  broadcast:
    'M12 12.5h.01M8.6 9a5 5 0 0 0 0 7M15.4 9a5 5 0 0 1 0 7M5.7 6a9 9 0 0 0 0 13M18.3 6a9 9 0 0 1 0 13',
  users:
    'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20a6.5 6.5 0 0 1 13 0M16 4.3a3.5 3.5 0 0 1 0 6.4M18 14.2a6.5 6.5 0 0 1 3.5 5.8',
  lock: 'M6 11h12v9H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
  play: 'M7.5 4.8v14.4L19.5 12z',
  gavel: 'M13.5 3.5l7 7M11 6l7 7M12.2 4.8l-5.4 5.4 7 7 5.4-5.4M10.4 13.6L3.5 20.5M3 21.5h10',
  scale: 'M12 4v16M7.5 20h9M5 7.5h14M5 7.5l-3 6a3 3 0 0 0 6 0zM19 7.5l-3 6a3 3 0 0 0 6 0z',
  columns: 'M3 9l9-5 9 5M5.5 9v9M10 9v9M14 9v9M18.5 9v9M3 20.5h18',
  globe:
    'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3 12h18M12 3c2.4 2.5 3.6 5.5 3.6 9s-1.2 6.5-3.6 9c-2.4-2.5-3.6-5.5-3.6-9S9.6 5.5 12 3z',
  briefcase: 'M4 7.5h16v12H4zM9 7.5V5h6v2.5M4 12.5h16',
  home: 'M4 11l8-7 8 7v9h-5.5v-6h-5v6H4z',
  heart:
    'M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.3a4.3 4.3 0 0 1 7.5 2.5C19.5 15.4 12 20 12 20z',
  chip: 'M7 7h10v10H7zM10 10h4v4h-4zM9.5 3.5V7M14.5 3.5V7M9.5 17v3.5M14.5 17v3.5M3.5 9.5H7M3.5 14.5H7M17 9.5h3.5M17 14.5h3.5',
  coins:
    'M12 4c4.4 0 8 1.3 8 3s-3.6 3-8 3-8-1.3-8-3 3.6-3 8-3zM4 7v5c0 1.7 3.6 3 8 3s8-1.3 8-3V7M4 12v5c0 1.7 3.6 3 8 3s8-1.3 8-3v-5',
  building: 'M5 21V4h10v17M15 9h4v12M3 21h18M8 8h4M8 12h4M8 16h4',
  grid: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  image: 'M4 5h16v14H4zM4 16l5-5 4 4 2.5-2.5L20 17M15.5 9.5h.01',
  chat: 'M5 5h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-8l-5 4v-4H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z',
  help: 'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zM9.6 9.4a2.5 2.5 0 1 1 3.4 2.4c-.6.3-1 .9-1 1.6v.5M12 16.8v.2',
  mail: 'M3.5 6h17v12h-17zM3.5 6.5l8.5 7 8.5-7',
  call: 'M6.5 3.5h3l1.5 4-2 1.3a11 11 0 0 0 6.2 6.2l1.3-2 4 1.5v3a2 2 0 0 1-2 2A16.5 16.5 0 0 1 4.5 5.5a2 2 0 0 1 2-2z',
} as const;

export type IconName = keyof typeof PATHS;

/** Domain icon names come from shared `domainIcon`, which returns plain strings. */
export const isIconName = (n: string): n is IconName => n in PATHS;

export function Icon({ n, s = 18, fill }: { n: IconName | string; s?: number; fill?: boolean }) {
  const d = isIconName(n) ? PATHS[n] : PATHS.building;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill={fill ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} />
    </svg>
  );
}
